export default function Footer() {
  return (
    <footer className="bg-[#01010b] py-8 px-6">
      <div className="container mx-auto">
        <div className="text-center text-[#bab3e2]">Copyright © 2025 Afi</div>
      </div>
    </footer>
  );
}
